import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const CtaSection = () => {
  return (
    <section className="py-24">
      <div className="container">
        <motion.div
          className="relative rounded-3xl overflow-hidden p-12 md:p-20 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {/* BG layers */}
          <div className="absolute inset-0 bg-gradient-primary opacity-95" />
          <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: `radial-gradient(circle at 30% 50%, hsl(0 0% 100% / 0.3) 0%, transparent 50%),
                             radial-gradient(circle at 70% 80%, hsl(0 0% 100% / 0.15) 0%, transparent 40%)`
          }} />
          <div className="absolute inset-0 opacity-[0.04]" style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, hsl(0 0% 100%) 1px, transparent 0)`,
            backgroundSize: '24px 24px'
          }} />

          <div className="relative z-10">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 text-white text-sm font-medium mb-6 backdrop-blur-sm">
                <Sparkles className="h-4 w-4" />
                Comece grátis, sem cartão de crédito
              </span>
            </motion.div>

            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-5 leading-tight">
              Pronto para digitalizar<br className="hidden md:block" /> seu restaurante?
            </h2>
            <p className="text-primary-foreground/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
              Junte-se a mais de 2.500 restaurantes que já usam o Via Menu. Setup em 5 minutos.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="bg-background text-foreground hover:bg-background/90 h-14 px-10 text-base font-semibold shadow-lg">
                <Link to="/cadastro">
                  Criar Minha Conta Grátis
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="h-14 px-8 text-base border-white/30 text-primary-foreground hover:bg-white/10 bg-transparent">
                <Link to="/lojademo">Ver Demonstração</Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaSection;
